import React, {FC, PropsWithChildren, useRef, useState, useEffect} from 'react';

import * as XLSX from 'xlsx';

// import library.
import { useFieldArray, useForm, useFormContext, Controller, FormProvider, FieldArrayWithId, ArrayPath } from 'react-hook-form';
import { useTranslation  } from 'react-i18next';

import { useSnackbar } from 'notistack';

import NumberFormat from 'react-number-format';
// mui ...
import {Avatar, Button, Grid, Typography, Link, Box, Paper, TextField, 
    MenuItem, IconButton, Checkbox, FormControlLabel, Stack } from '@mui/material';

    import InputAdornment from '@mui/material/InputAdornment';
import ArrowDropDownCircleIcon from '@mui/icons-material/ArrowDropDownCircle';
import BoltIcon from '@mui/icons-material/Bolt';

import FileDownloadIcon from '@mui/icons-material/FileDownload';

import { ThreeDots, ThreeCircles  } from 'react-loader-spinner';

import { useRecoilState, useSetRecoilState, useRecoilValue } from 'recoil';

import entityService  from 'features/services/Entity';

import EnhancedTable, {_DataType, HeadCell, RowCheckedMode} from './EnhancedTable';
import { FaSearch } from 'react-icons/fa';
import {SiMicrosoftexcel} from 'react-icons/si';
import { MdPictureAsPdf } from 'react-icons/md';

import { pink } from '@mui/material/colors';

import { flexBetweenCenter, fullWidthFlex, justifyCenter, typographyGroupBoxStyling } from 'themes/commonStyles';

import { FormDialog } from 'components/ui/FormDialog';
import { BasicTextFilterForm } from 'components/ui/BasicTextFilterForm';

import useEnumerationService from 'features/configuration/services/Enumeration';
import useBusinessApplicationService, { useBasicFilterApplicationQuery } from 'features/setup/services/ApplicationQuery';

import { IBusinessApplication, IApplicationQuery, 
    IApplicationQueryParameter, ParameterDataType, toBaseType, toDataType, defaultValue, IApplicationQueryReport } from 'features/setup/models/ApplicationQuery';
import ArrayField, { BaseType, } from './ArrayField';
import { IFeatureParameter } from 'library/interface';
import { isFalsy } from 'utility-types';
import { GrDocumentDownload, GrDocumentPdf } from 'react-icons/gr';

import BasicButtonList from './BasicButtonList';
import { hubConnectionIdAtom, colorsAtom } from 'library/store';

import { exportToExcel, exportToExcelEx } from 'library/xlsx-export';


export interface BasicImport2FormProps<T1 extends {}, T2 extends {} > {

    fileNameToLoad?: string,

    stateItems : [ {first: T1[], second: T2[]  }, 
        React.Dispatch<React.SetStateAction<{first: T1[], second: T2[]  }>>],
    
    columns: {first: (keyof T1)[], second: (keyof T2)[] } ,
    defaultItem: {first: T1, second: T2},

    sheetName: {first: string, second: string}
}


export default function BasicImport2Form<T1 extends {}, T2 extends {}>(props: BasicImport2FormProps<T1,T2>)  {
    
    const { stateItems, columns, defaultItem, sheetName, fileNameToLoad } = props;

    const { t, i18n } = useTranslation();
    const { enqueueSnackbar } = useSnackbar();

    //const [filterElements, setFilterElements] = filterElementsState;

    const [hubConnectionId, setHubConnectionId] = useRecoilState(hubConnectionIdAtom);
   
    const [isLoading, setIsLoading] = useState<boolean>(false);

    const { getApplicationQueryParameters, generateApplicationQueryXlsx, generateApplicationQueryPdf } = useBusinessApplicationService();
    const {getAsOptions } = useEnumerationService();

    const {retrieveEntity} = entityService();

    const [Colors, setColors] = useRecoilState(colorsAtom);

    const [openColumsList, setOpenColumsList] = useState<boolean>(false);
    const handleDisplayExcelColumns = (event: any) => {
        setOpenColumsList(true);
    }

    function getType<T>(col: keyof T, item: T) : _DataType {
        if(item[col] instanceof Date) 
            return 'date';
        else if(typeof item[col] === 'number')
            return 'numeric';
        else if(typeof item[col] === 'boolean')
            return 'boolean';

        return 'string';
    }
        

    const [fileName, setFileName] = useState<string>('');
    const [openReportChoice, setOpenReportChoice] = useState<boolean>(false);
    const handleOpenReports = () => {
        setOpenReportChoice(true);
    }

    function handleDownloadTemplateFile<T>(data: T[], sheetName: string, cols: (keyof T)[] ) {
        
        exportToExcelEx(data, `${t('File')} ${sheetName}` ,sheetName, cols);
      }

    function openFileDialog(  ) {
        (document as any).getElementById("file-upload-import").click();        
      }
   
      const setFile = (_event: any) => {
        let f = _event.target.files![0];


        if(!isFalsy(fileNameToLoad) && fileNameToLoad.trim().toLowerCase() !== f.name.trim().toLowerCase()) {
            enqueueSnackbar( `${t('The file name is not valid')} : ${fileNameToLoad}`, { variant: 'warning',
                anchorOrigin : { horizontal: 'center', vertical: 'top' }, autoHideDuration : 3000 }); 
            return;
        }

        var reader = new FileReader();
        
        reader.onload = function (event: ProgressEvent<FileReader> ) {
            try {
                var binaryString = event.target?.result as string; //  reader.result as string; // event
                const workbook = XLSX.read(binaryString, {type: 'binary'});

                if(workbook.SheetNames.length < 2 ) {
                    enqueueSnackbar( t('Invalid data !!!'), { variant: 'warning',
                        anchorOrigin : { horizontal: 'center', vertical: 'top' }, autoHideDuration : 2000 }); 
                    return;
                }
                
                if( [sheetName.first, sheetName.second].some(n => !workbook.SheetNames.includes(n)) ) {
                    enqueueSnackbar( `${t('Invalid data !!!')} : ${sheetName.first}, ${sheetName.second} `, 
                        { variant: 'warning', anchorOrigin : { horizontal: 'center', vertical: 'top' }, autoHideDuration : 2000 }); 
                    return;
                }

                //const sheetName = workbook.SheetNames[0];
                const firstWorkSheet = workbook.Sheets[sheetName.first];
                const secondWorkSheet = workbook.Sheets[sheetName.second];
                

                setFileName(f.name);

                const firstJsonData: T1[] = XLSX.utils.sheet_to_json(firstWorkSheet);   
                const secondJsonData: T2[] = XLSX.utils.sheet_to_json(secondWorkSheet);   
                

                stateItems[1]( {first: firstJsonData as unknown as T1[],
                                second: secondJsonData as unknown as T2[] }  );     
                                 

            }catch (err) {
                console.error(err);
            }
          
        };
  
        reader.onerror = function () {
          console.log("File load failed");
        };
    
        reader.readAsArrayBuffer(f);
      }
        
    return ( 
    <>
        
        <Grid container component="main" sx={{  width: '100%' }} alignItems="flex-start">
            <Grid item xs={12} sm={12} md={12} component={Paper} square>
                <Stack flexDirection='column' sx={{ width: '100%' }} > 
                    <Box sx={{ mt: 1, width: '100%', pt: 0 }} >
                        <Stack flexDirection='row'>
                            <Box sx={{ mt: 1, width: '50%', pt: 0 }} >                                                                
                                <Button onClick={ () => openFileDialog()} key={`lg - ${fileName} `} id={`lg - ${fileName}`}>
                                    <input type="file" id="file-upload-import" accept=".xlsx" style={{ display: "none" }} onChange={ (_event) => setFile(_event) }/>
                                    {isFalsy(fileName) ? `${t('Click to toad file')} ...`: `${fileName} -> ${t('Click to change')}`}
                                </Button>                             
                            </Box>
                            <Box sx={{ ...justifyCenter, mt: 1, width: '50%', pt: 0 }} >
                                <Button>
                                  <Typography  variant="h6" id="tableTitle" color="primary" noWrap sx={{...typographyGroupBoxStyling}}>
                                    {`${t('Columns of Excel file')}`}
                                  </Typography>
                                  <Box sx={{ ...justifyCenter, ml: 1 }} >                                                     
                                    <GrDocumentDownload color={Colors.menuIcon} size={24} onClick={handleDisplayExcelColumns}  />
                                  </Box>  
                                </Button>                                
                              </Box>
                        </Stack>  
                    </Box>                     
                    
                    { openColumsList && <FormDialog open={openColumsList} maxWidth='md' height='80vh'
                        okText={t('OK')} cancelText='' title={'... ==> '} onCancel={()=> {}} 
                        onClose={()=> {setOpenColumsList(false);}} onOk={()=> {setOpenColumsList(false);}}  >
                            <Box sx={{ ...justifyCenter, mt: 1, width: '100%', pt: 0 }} >
                                <EnhancedTable<T1> rows={[{...defaultItem.first}]} 
                                    headCells={ columns.first.map(x => ({id: x, label: x, display: true, type: getType(x, defaultItem.first) } as HeadCell<T1>)) } 
                                    title={`${t('Template')} - ${sheetName.first}`} hideExportButton={true}
                                    objKey={columns.first[0]}
                                    
                                    onRowSelected={undefined} rowCheckedMode='single'
                                    onRowCheckedSelectChange={undefined} order='asc' orderBy={columns.first[0]}
                                    onRowDoubleClick={undefined} 
                                    rowActionIcon={undefined}
                                    toolbarActions={[
                                        { toolTip: `${t('Download')}...`, onClickIcon: (event: any) => {handleDownloadTemplateFile<T1>([{...defaultItem.first}], sheetName.first, columns.first )} ,icon: FileDownloadIcon,  },
                                    ]}
                                    />
                            </Box>

                            <Box sx={{ ...justifyCenter, mt: 1, width: '100%', pt: 0 }} >
                                <EnhancedTable<T2> rows={[{...defaultItem.second}]} 
                                    headCells={ columns.second.map(x => ({id: x, label: x, display: true, type: getType(x, defaultItem.second) } as HeadCell<T2>)) } 
                                    title={`${t('Template')} - ${sheetName.second}`} hideExportButton={true}
                                    objKey={columns.second[0]}
                                    
                                    onRowSelected={undefined} rowCheckedMode='single'
                                    onRowCheckedSelectChange={undefined} order='asc' orderBy={columns.second[0]}
                                    onRowDoubleClick={undefined} 
                                    rowActionIcon={undefined}
                                    toolbarActions={[
                                        { toolTip: `${t('Download')}...`, onClickIcon: (event: any) => {handleDownloadTemplateFile([{...defaultItem.second}], sheetName.second, columns.second)} ,icon: FileDownloadIcon,  },
                                    ]}
                                    />
                            </Box>

                            
                        </FormDialog>  }
                </Stack>  
            </Grid>
            <Grid item xs={12} component={Paper} square>                
                <Box sx={{ mt: 1, width: '100%' }} >                      
                        
                </Box>
            </Grid>  
        </Grid>
        
    </>
    ); 
}


